export const PWA_SERVICE_WORKER_PATH = "/sw.js";
